import { t } from "@/i18n-js/instance";
import { Badge } from "@/react/components/SettingsApp/CompassCompat/Badge";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

export const InReviewBadge = ({
  shouldShowTooltip = true,
}: {
  shouldShowTooltip?: boolean;
}) => {
  const inReviewTooltip = t("messaging.in_review_tooltip");
  return (
    <TippyV2
      enabled={shouldShowTooltip}
      arrow={false}
      className="inline-flex shrink-0"
      interactive={false}
      placement="top-start"
      content={inReviewTooltip}
    >
      <span className="inline-flex shrink-0 whitespace-nowrap">
        <Badge
          label={t("messaging.in_review")}
          variant="warning"
          labelClassName="text-warning font-medium text-xs"
          className="!border-none bg-warning/10 px-2"
        />
      </span>
    </TippyV2>
  );
};
